import { StackScreenProps } from "@react-navigation/stack";
import {
  CheckoutInvoiceRootScreenParamList,
  CheckoutRootParamList,
} from "../../../../types";
import {
  Button,
  Card,
  Divider,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import { SaleSaleItemsSummary } from "../../components/SaleSaleItemsSummary";
import { useInvoiceRootScreenContextProvider } from "../CheckoutInvoiceRootScreen/hooks";
import { SaleTotalsSummary } from "../../components/SaleTotalsSummary";
import React from "react";
import { Colors } from "react-native-ui-lib";
import { useTranslation } from "../../../../utilities/i18n";
import { SaleState } from "../../../../utilities/data/model/Sale";
import { CustomerCard } from "../../components/CustomerCard";

export type CheckoutInvoiceScreenProps = StackScreenProps<
  CheckoutInvoiceRootScreenParamList & CheckoutRootParamList,
  "CheckoutInvoiceScreen"
>;

export const CheckoutInvoiceScreen = ({
  navigation,
}: CheckoutInvoiceScreenProps) => {
  const { t } = useTranslation("quote");
  const [submitting, setSubmitting] = React.useState(false);
  const screenContext = useInvoiceRootScreenContextProvider();
  const { sale } = screenContext;

  const handleOnCompleteInvoice = React.useCallback(async () => {
    try {
      setSubmitting(true);
      await sale.transitionToState(SaleState.INVOICE_OPEN);
      navigation.reset({
        index: 0,
        routes: [{ name: "CheckoutSummaryRootScreen" }],
      });
      return false;
    } catch (err) {
      console.log(err);
    }
    setSubmitting(false);
  }, []);

  // @ts-ignore
  const customerCardMarkup = <CustomerCard customerId={sale.customer.id} />;

  const itemsMarkup = (
    <Card title={t("common:items")}>
      <SaleSaleItemsSummary sale={sale} />
    </Card>
  );

  const totalsMarkup = (
    <Card title={t("common:totals")}>
      <SaleTotalsSummary sale={sale} />
    </Card>
  );

  const footerMarkup = (
    <Button
      disabled={submitting}
      label={t("button.complete_invoice")}
      backgroundColor={Colors.action}
      color="white"
      onPress={handleOnCompleteInvoice}
    ></Button>
  );

  return (
    <Page
      title={t("create_invoice_title")}
      secondaryTitle={t("create_invoice_subtitle")}
      footer={footerMarkup}
    >
      <Stack vertical>
        {customerCardMarkup}
        <Divider />
        {itemsMarkup}
        {totalsMarkup}
      </Stack>
    </Page>
  );
};
